import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormContainer = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    margin-top: -11px;
  `}
`

export const Breadcrumb = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-top: 5px;
    margin-bottom: 0.5rem;
  `}
`

export const BreadcrumbItem = styled.span`
  ${() => css`
    color: #64748b;
    font-weight: 400;
  `}
`

export const BreadcrumbSeparator = styled.span`
  ${() => css`
    color: #64748b;
    font-weight: 400;
  `}
`

export const BreadcrumbItemBold = styled.span`
  ${() => css`
    color: #283897;
    font-weight: 700;
  `}
`

export const MainTitle = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: ${theme.colors.secondary};
    line-height: 1.4;
    margin-bottom: 0.5rem;
  `}
`

export const InfoBanner = styled(Box)`
  ${() => css`
    width: 100%;
    padding: 0.75rem 1rem;
    background-color: #e8f4fd;
    border: 1px solid #3b82f6;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    svg {
      color: #3b82f6;
      flex-shrink: 0;
      margin-top: 0.125rem;
    }
  `}
`

export const InfoText = styled.p`
  ${() => css`
    margin: 0;
    font-size: 0.875rem;
    color: #1e40af;
    line-height: 1.5;
  `}
`

export const Section = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  `}
`

export const SectionHeader = styled.h3`
  ${() => css`
    margin: 0;
    font-size: 0.875rem;
    font-weight: 600;
    color: #2d3748;
  `}
`

export const SectionHeaderWithIcon = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const IconBackground = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 8px;
    background-color: #EFE9E9;
  `}
`

export const CollaboratorCard = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    background-color: #fff;
  `}
`

export const CollaboratorInfo = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 1rem;
  `}
`

export const CollaboratorName = styled.div`
  ${() => css`
    font-size: 0.875rem;
    font-weight: 600;
    color: #2d3748;
  `}
`

export const CollaboratorMatricula = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #718096;
  `}
`

export const CollaboratorBadge = styled(Box)`
  ${() => css`
    padding: 6px 24px;
    border-radius: 30px;
    font-size: 13px;
    font-weight: 600;
    background-color: #dbeafe;
    color: #2563eb;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
  `}
`

export const CollaboratorDataGrid = styled(Box)`
  ${() => css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
    padding: 1rem;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
  `}
`

export const DataField = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  `}
`

export const DataLabel = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #718096;
    font-weight: 500;
  `}
`

export const DataValue = styled.div`
  ${() => css`
    font-size: 0.875rem;
    color: #2d3748;
    font-weight: 400;
  `}
`

export const FormFieldsGrid = styled(Box)`
  ${() => css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
  `}
`

export const DisabledFieldWrapper = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
  `}
`

export const FieldLabel = styled.label`
  ${({ theme }) => css`
    display: block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    margin-bottom: 6px;
  `}
`

export const DisabledField = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 1rem;
    background-color: #f7fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
  `}
`

export const Card = styled(Box)`
  ${() => css`
    width: 100%;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  `}
`

export const CardHeader = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;

    svg {
      color: #64748b;
    }
  `}
`

export const CardSectionHeader = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    background-color: transparent;
  `}
`

export const CardSectionIconBg = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 8px;
    background-color: #EEEEF1;

    svg {
      width: 18px;
      height: 18px;
      color: inherit;
    }
  `}
`

export const CardSectionTitle = styled.div`
  ${() => css`
    font-size: 1.125rem;
    font-weight: 600;
    color: #1e293b;
  `}
`

export const CardTitle = styled.div`
  ${() => css`
    font-size: 0.875rem;
    font-weight: 600;
    color: #1e293b;
  `}
`

export const CardSubtitle = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #64748b;
    margin-top: 0.125rem;
  `}
`

export const CardItem = styled(Box)`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    position: relative;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 20px;
      right: 20px;
      height: 1px;
      background-color: rgba(40, 56, 151, 0.6);
    }
  `}
`

export const CardItemLabel = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    font-size: 0.875rem;
    color: #475569;
  `}
`

export const LabelWithIcon = styled.div`
  ${() => css`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
  `}
`

export const CardItemSubtext = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #94a3b8;
  `}
`

export const CardItemValue = styled.div`
  ${() => css`
    font-size: 1rem;
    font-weight: 600;
    color: #1e293b;
    width: 130px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 30px;
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum' 1;
  `}
`

export const CardItemValueWithIcon = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 130px;
    flex-shrink: 0;
    margin-right: 30px;
    position: relative;

    > div {
      margin-right: 0;
    }
  `}
`

export const EditIconWrapper = styled.span`
  ${() => css`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #64748b;
    position: absolute;
    right: -24px;
    top: 50%;
    transform: translateY(-50%);

    &:hover {
      color: #283897;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  `}
`

export const CardItemCode = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #94a3b8;
    text-align: right;
  `}
`

export const InfoIconWrapper = styled.span`
  ${() => css`
    display: inline-flex;
    align-items: center;
    cursor: help;
    flex-shrink: 0;
    line-height: 1;
    padding: 0;
    margin: 0;
  `}
`

export const InfoIconContainer = styled.span`
  ${() => css`
    display: inline-block;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    cursor: help;
    flex-shrink: 0;
    line-height: 1;
    padding: 0;
    margin: 0;
    vertical-align: middle;

    svg {
      width: 14px;
      height: 14px;
      color: #94a3b8;
      display: block;
    }

    &:hover svg {
      color: #64748b;
    }
  `}
`

export const TooltipWrapper = styled.span`
  ${() => css`
    display: inline-flex;
    width: fit-content;
    align-items: center;
    
    > div {
      width: fit-content !important;
      display: inline-flex !important;
    }
  `}
`

export const SummaryCard = styled(Card)`
  ${() => css`
    background-color: #fff;
  `}
`

export const SummaryGrid = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
  `}
`

export const SummaryItem = styled(Box)`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    position: relative;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 10px;
      right: 10px;
      height: 1px;
      background-color: #e2e8f0;
    }
  `}
`

export const SummaryItemLeft = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.625rem;
  `}
`

export const SummaryLabel = styled.div`
  ${() => css`
    font-size: 0.875rem;
    font-weight: 500;
    color: #1e293b;
  `}
`

export const SummaryValue = styled.div`
  ${() => css`
    font-size: 1rem;
    font-weight: 500;
    color: #475569;
    width: 130px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 30px;
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum' 1;
  `}
`

export const SummaryTotal = styled(Box)`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.875rem 1rem;
    background-color: transparent;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
  `}
`

export const SummaryTotalLabel = styled.div`
  ${() => css`
    font-size: 0.9375rem;
    font-weight: 700;
    color: #1e293b;
  `}
`

export const SummaryTotalValue = styled.div`
  ${() => css`
    font-size: 1rem;
    font-weight: 700;
    color: #283897;
    width: 130px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 30px;
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum' 1;
  `}
`

export const SummaryUpdatedBadge = styled.span`
  ${() => css`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    margin-left: auto;
    padding: 0.25rem 0.625rem;
    border-radius: 999px;
    background-color: #dcfce7;
    color: #15803d;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;

    svg {
      width: 14px;
      height: 14px;
      color: inherit;
    }
  `}
`

export const SummaryDeduction = styled(Box)`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
  `}
`

export const SummaryDeductionLeft = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #dc2626;

    svg {
      flex-shrink: 0;
    }
  `}
`

export const SummaryDeductionLabel = styled.div`
  ${() => css`
    font-size: 0.875rem;
    font-weight: 500;
    color: #dc2626;
  `}
`

export const SummaryDeductionValue = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.375rem;
    width: 130px;
    flex-shrink: 0;
    margin-right: 30px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #dc2626;
  `}
`

export const SummaryDeductionAmount = styled.span`
  ${() => css`
    padding: 0.125rem 0.625rem;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    background-color: #fff;
    color: #dc2626;
    font-size: 0.875rem;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum' 1;
  `}
`

export const SummaryWarning = styled(Box)`
  ${() => css`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin: 0 1rem 1rem;
    padding: 0.5rem 0.75rem;
    background-color: #fefce8;
    border: 1px solid #fde68a;
    border-radius: 6px;

    svg {
      flex-shrink: 0;
      margin-top: 0.0625rem;
      color: #f59e0b;
    }
  `}
`

export const SummaryWarningText = styled.p`
  ${() => css`
    margin: 0;
    font-size: 0.75rem;
    color: #92400e;
    line-height: 1.4;
  `}
`

export const BalanceCard = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 1rem 1rem;
    padding: 0.875rem 1rem;
    background-color: #f8fbff;
    border: 1px solid #93c5fd;
    border-radius: 8px;
  `}
`

export const BalanceLeft = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
  `}
`

export const BalanceIconBg = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 8px;
    background-color: #283897;
    color: #fff;

    svg {
      width: 18px;
      height: 18px;
      color: inherit;
    }
  `}
`

export const BalanceTitleRow = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.375rem;
  `}
`

export const BalanceLabel = styled.div`
  ${() => css`
    font-size: 0.9375rem;
    font-weight: 700;
    color: #1e293b;
  `}
`

export const BalanceSubtext = styled.div`
  ${() => css`
    font-size: 0.75rem;
    color: #64748b;
    margin-top: 0.125rem;
  `}
`

export const BalanceValue = styled.div`
  ${() => css`
    font-size: 1rem;
    font-weight: 700;
    color: #283897;
    width: 130px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 14px;
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum' 1;
  `}
`
